export default __webpack_public_path__ + "static/media/man-2-desktop.27eef4d7.jpg";